import React, { useEffect, useState } from "react";
import {
  Smartphone, BatteryCharging, PlugZap, Camera, Layers, Droplets,
  Laptop, Tablet, Wrench, Cpu, HardDrive, ShieldCheck
} from "lucide-react";
import { api } from "../../lib/api";

const ICONS = {
  smartphone: Smartphone, "battery-charging": BatteryCharging, "plug-zap": PlugZap,
  camera: Camera, layers: Layers, droplets: Droplets, laptop: Laptop, tablet: Tablet,
  wrench: Wrench, cpu: Cpu, "hard-drive": HardDrive, shield: ShieldCheck,
};

export default function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/content/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <section id="tjenester" className="py-16 sm:py-24 bg-offwhite" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <span className="text-sm font-semibold uppercase tracking-widest text-electric">Tjenester</span>
          <h2 className="mt-2 font-heading text-3xl sm:text-4xl font-bold text-navy">
            Dette kan vi hjelpe deg med
          </h2>
          <p className="mt-3 text-ink/70">
            Vi reparerer det meste av mobil, nettbrett, Mac og PC – med kvalitetsdeler og
            personlig oppfølging.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
          {services.map((s) => {
            const Icon = ICONS[s.icon] || Wrench;
            return (
              <div
                key={s.id}
                className="group rounded-xl border border-hairline bg-white p-6 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all"
                data-testid={`service-card-${s.title}`}
              >
                <span className="flex items-center justify-center w-12 h-12 rounded-lg border border-electric/20 bg-electric/5 text-electric group-hover:bg-electric group-hover:text-white transition-colors">
                  <Icon className="w-6 h-6" strokeWidth={1.8} />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-navy">{s.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-ink/70">{s.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
